import { environment } from "src/environments/environment";

export type ApiKeyProduct = 'esign' | 'estamp';

export interface ApiKeyPreset {
  label: string;
  key: string;
}

export const ESIGN_API_KEY_PRESETS: ApiKeyPreset[] = [
  { label: 'eSign Demo Key', key: environment.esignApiKey },
];

export const ESTAMP_API_KEY_PRESETS: ApiKeyPreset[] = [
  { label: 'eStamp Demo Key', key: environment.estampApiKey },
];

export function apiKeyPresetsFor(product: ApiKeyProduct): ApiKeyPreset[] {
  const presets = product === 'estamp'
    ? ESTAMP_API_KEY_PRESETS
    : ESIGN_API_KEY_PRESETS;

  return presets.filter(preset => !!preset.key.trim());
}

export function apiKeyPresetLabel(
  product: ApiKeyProduct,
  apiKey: string
): string | undefined {

  const normalizedKey = (apiKey || '').trim();

  if (!normalizedKey) {
    return undefined;
  }

  return apiKeyPresetsFor(product)
    .find(preset => preset.key.trim() === normalizedKey)
    ?.label;
}
